<template>
    <el-dialog :title="title" :visible.sync="showModal" :close-on-click-modal="false" :destroy-on-close="true"
        width="512px">
        <el-form ref="form" :model="form" :rules="rules" label-width="85px">
            <el-form-item label="商家头像" prop="head_img">
                <upload-one v-model="form.head_img" width="200px" height="200px"></upload-one>
            </el-form-item>
            <el-form-item label="商家名称" prop="name">
                <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="商家介绍" prop="details">
                <el-input type="textarea" :rows="4" placeholder="请输入介绍内容" v-model="form.details" />
            </el-form-item>
            <el-form-item label="联系人" prop="contact_name">
                <el-input v-model="form.contact_name"></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="contact_phone">
                <el-input v-model.number="form.contact_phone"></el-input>
            </el-form-item>
            <el-form-item label="账号" prop="account">
                <el-input v-model="form.account"></el-input>
            </el-form-item>
            <el-row type="flex" justify="end">
                <el-button @click="trunOff">取消</el-button>
                <el-button type="primary" :loading="submitting" @click="onSubmit">确认</el-button>
            </el-row>
        </el-form>
    </el-dialog>
</template>

<script>
import { merchant } from "@/api/userManagement"

export default {
    data: () => ({
        // 表单规则
        rules: {
            head_img: [
                { required: true, message: "请上传商家头像", trigger: 'blur' }
            ],
            name: [
                { required: true, message: "请输入商家名称", trigger: 'blur' }
            ],
            details: [
                { required: true, message: "请输入商家介绍", trigger: 'blur' }
            ],
            contact_name: [
                { required: true, message: "请输入联系人", trigger: 'blur' }
            ],
            contact_phone: [
                { required: true, message: "请输入联系电话", trigger: 'blur' },
            ],
            account: [
                { required: true, message: "请输入账号", trigger: 'blur' }
            ]
        },
        // 表单数据字段
        form: {
            head_img: null,
            name: '',
            details: '',
            contact_name: '',
            contact_phone: '',
            account: ''
        },
        submitting: false
    }),
    props: {
        // 展示
        show: {
            default: false,
            type: Boolean
        },
        // 模式
        type: {
            default: 'add',
            type: String
        },
        // 编辑的数据
        editData: null | Object
    },
    methods: {
        // 自我关闭
        trunOff() {
            this.showModal = false
        },
        handleUpdateFormModelByModalType() {
            const handlers = {
                add: () => {
                    this.form = {
                        head_img: null,
                        name: '',
                        details: '',
                        contact_name: '',
                        contact_phone: '',
                        account: ''
                    }
                },
                edit: () => {
                    const { id, head_img, name, details, contact_name, contact_phone, account } = this.editData
                    this.form = {
                        id,
                        head_img,
                        name,
                        details,
                        contact_name,
                        contact_phone,
                        account
                    }
                }
            }

            handlers[this.type]()
        },
        onSubmit() {
            const { form } = this

            const handlers = {
                add: () => {
                    this.$refs["form"].validate(async valid => {
                        if (valid) {
                            this.submitting = true
                            try {
                                await merchant.create(form)
                                this.$message({
                                    message: '添加成功!',
                                    type: 'success'
                                });
                                this.$emit("onUpdate")
                                this.trunOff()
                            } catch {
                                this.$message.error('添加失败!')
                            } finally {
                                this.submitting = false
                            }
                        }
                    })
                },
                edit: () => {
                    this.$refs["form"].validate(async valid => {
                        if (valid) {
                            this.submitting = true
                            try {
                                await merchant.create(form)
                                this.$message({
                                    message: '编辑成功!',
                                    type: 'success'
                                });
                                this.$emit("onUpdate")
                                this.trunOff()
                            } catch {
                                this.$message.error('编辑失败!')
                            } finally {
                                this.submitting = false
                            }
                        }
                    })
                    console.log("run edit");
                }
            }

            handlers[this.type]()
        }
    },
    computed: {
        showModal: {
            get() {
                return this.show;
            },
            set(val) {
                this.$emit('update:show', val);
            }
        },
        title() {
            const { type } = this

            const title = {
                add: "新建数据",
                edit: "编辑数据"
            }

            return title[type]
        }
    },
    watch: {
        show(newVal) {
            if (newVal) {
                this.handleUpdateFormModelByModalType()
            }
        }
    }
}
</script>

<style lang="scss" scoped>

</style>